import { Uuid } from "@/domains/global/identifiers";
import { sortBy } from "lodash-es";
import { v5 as uuidv5 } from "uuid";

export const combineUuidsUsingNamespace = ({
  namespace,
  uuids,
}: {
  namespace: Uuid;
  uuids: Uuid[];
}): Uuid => {
  // Stable derivation: uppercase, sort, join with `::`, then UUIDv5.
  const upperCasedUuids = uuids.map(id => id.toUpperCase());
  const sortedUuids = sortBy(upperCasedUuids);
  const combinedUuidStr = sortedUuids.join("::");

  const namespaceStr = namespace.toUpperCase();

  return uuidv5(combinedUuidStr, namespaceStr);
};
